import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import { useHistory, Link } from "react-router-dom";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Register.css";

const Register = () => {
  const { enqueueSnackbar ,closeSnackbar} = useSnackbar();
  const [username,setUsername]=useState("");
  const [email,setEmail] = useState("")
  const [password,setPassword]=useState("");
  const [confirmPassword,setConfirmPassword]=useState("");
  const [loading,setLoading]=useState(false);
  const history=useHistory(); 

  const changeName= (e)=>{
    setUsername(e.target.value);
  }
  const changePassword= (e)=>{
    setPassword(e.target.value);
  }
  const changeConfirmPassword= (e)=>{
    setConfirmPassword(e.target.value);
  }
  const changeEmail = (e)=>{
    setEmail(e.target.value)
  }

  // TODO: CRIO_TASK_MODULE_REGISTER - Implement the register function
// import { useHistory, Link } from "react-router-dom";

// const Register = () => {
//   const { enqueueSnackbar } = useSnackbar();


  /**
   * Definition for register handler
   * - Function to be called when the user clicks on the register button or submits the register form
   *
   * @param {{ username: string, password: string, confirmPassword: string }} formData
   *  Object with values of username, password and confirm password user entered to register
   *
   * API endpoint - "POST /auth/register"
   *
   * Example for successful response from backend for the API call:
   * HTTP 201
   * {
   *      "success": true,
   * }
   *
   * Example for failed response from backend for the API call:
   * HTTP 400
   * {
   *      "success": false,
   *      "message": "Username is already taken"
   * }
   */
  const register = async (formData) => {
    try{
     let isValid= validateInput({username,email,password,confirmPassword});
     if(isValid){
      let dataSending ={name:username,password,email}
      let url = config.endpoint+"/auth/register";
     // console.log(url);
      setLoading(true);
      const res= await axios.post(url,dataSending);
      setLoading(false);
      console.log(res);
      enqueueSnackbar("Registered Successfully", { 
        variant: 'success',
      });
     // persistLogin()
      history.push("/login",{from : "Register Page"})
     }
   
    //return res;
    }catch(error){
     // console.log(error.response)
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data.message);
        enqueueSnackbar(error.response.data.message, { 
          variant: 'error',
      });
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
        enqueueSnackbar("Something went wrong. Check that the backend is running, reachable and returns valid JSON."  , { 
          variant: 'error',
      });
      } else {
        // Something happened in setting up the request that triggered an Error
        enqueueSnackbar("Something went wrong. Check that the backend is running, reachable and returns valid JSON."  , { 
          variant: 'error',
      });
      }
    }
    

  };

  // TODO: CRIO_TASK_MODULE_REGISTER - Implement user input validation logic
  /**
   * Validate the input values so that any bad or illegal values are not passed to the backend.
   *
   * @param {{ username: string, password: string, confirmPassword: string }} data
   *  Object with values of username, password and confirm password user entered to register
   *
   * @returns {boolean}
   *    Whether validation has passed or not
   *
   * Return false if any validation condition fails, otherwise return true.
   * (NOTE: The error messages to be shown for each of these cases, are given with them)
   * -    Check that username field is not an empty value - "Username is a required field"
   * -    Check that username field is not less than 6 characters in length - "Username must be at least 6 characters"
   * -    Check that password field is not an empty value - "Password is a required field"
   * -    Check that password field is not less than 6 characters in length - "Password must be at least 6 characters"
   * -    Check that confirmPassword field has the same value as password field - Passwords do not match
   */
  const validateInput = (data) => {
    let valid=true;
    let emailCheck = /\S+@\S+\.\S+/.test(data.email);
    if(data.username==="" || data.username===null){
      valid=false;
      enqueueSnackbar("Username is a required field", { 
        variant: 'warning',
      });
    }else if(data.username.length<6){
      valid=false;
      enqueueSnackbar("Username must be at least 6 characters", { 
        variant: 'warning',
      });
    
    }else if(data.email === "" || email == null){
      valid=false;
      enqueueSnackbar("Email is reqiured field", { 
        variant: 'warning',
      });
    }else if(!emailCheck){
      valid =false;
      enqueueSnackbar("Enter Valid Email", { 
        variant: 'warning',
      });
    }else if(data.password==="" || data.password===null){
      valid=false;
      enqueueSnackbar("Password is a required field", { 
        variant: 'warning',
      });
    }else if(data.password.length<8){
      valid=false;
      enqueueSnackbar("Password must be at least 8 characters and must contain atlest 1 digit.", { 
        variant: 'warning',
      });
    }else if(data.password!== data.confirmPassword){
      valid=false;
      enqueueSnackbar("Passwords do not match", { 
        variant: 'warning',
      });
    }
    return valid;
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      minHeight="100vh"
    >
      <Header hasHiddenAuthButtons={true} />
      <Box className="content">
        <Stack spacing={2} className="form">
          <h2 className="title">Register</h2>
          <TextField
            id="username"
            label="Username"
            variant="outlined"
            title="Username"
            name="username"
            value={username}
            onChange={changeName}
            placeholder="Enter Username"
          >
          </TextField>
          <TextField
            id="email"
            label="Email"
            variant="outlined"
            title="Email"
            name="email"
            placeholder="Enter E-mail"
            value={email}
            onChange={changeEmail}
            fullWidth
          />
          <TextField
            id="password"
            variant="outlined"
            label="Password"
            name="password"
            type="password"
            helperText="Password must be at least 8 characters and must contain atlest 1 digit"
            fullWidth
            placeholder="Enter a password with minimum 6 characters"
            value={password}
            onChange={changePassword}
          />
          <TextField
            id="confirmPassword"
            variant="outlined"
            label="Confirm Password"
            name="confirmPassword"
            type="password"
            value={confirmPassword}
            onChange={changeConfirmPassword}
            fullWidth
          />
          {
            loading ? (<Box className="loading-icon">
            <CircularProgress />
            </Box>)
            : (
              <Button className="button" variant="contained" onClick={register} >
              Register Now
             </Button>
            )
          }
        
          <p className="link secondary-action">
            Already have an account?{" "}
            <Link to="/Login">Login here</Link>
          </p>
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
};

export default Register;
